import React from "react";
import MobilePage from "../../../Components/MobilePage";
import { Trans } from "react-i18next";

import MDContainer from "@mui/material/Container";
import makeStyles from "@mui/styles/makeStyles";
import { useRouteMatch } from "react-router-dom";
import { usePictureSet } from "../../hooks/usePictureSet";
import AppBar from "../../Components/AppBar";
import SubjectHeader from "@/react/Webshop/Mobile/Pages/MyPictureSet/Components/SubjectHeader";
import PictureSetPictures from "@/react/Webshop/Mobile/Pages/MyPictureSet/Components/PictureSetPictures";
import PictureSetActions from "@/react/Webshop/Mobile/Pages/MyPictureSet/Components/PictureSetActions";

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: "8px",
  },
  cardContent: {
    padding: 0,
    "& img": {
      width: "100%",
    },
  },
}));

const MyPictureSet = () => {
  const { params } = useRouteMatch();
  const { notFound, pictureSet } = usePictureSet(params.pictureSetUuid);

  if (!pictureSet) {
    return <Trans>Loading</Trans>;
  }

  return (
    <MobilePage requireUser>
      <AppBar />

      <SubjectHeader pictureSet={pictureSet} />

      <PictureSetActions pictureSet={pictureSet} />

      <MDContainer>
        <PictureSetPictures pictureSet={pictureSet} />
      </MDContainer>
    </MobilePage>
  );
};

export default MyPictureSet;
